import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import FirstStep from '../FirstStep'
import RestartPassword from '../RestartPassword'
import './index.scss'
const LoginContent2 = observer(() => {
  const [step, setStep] = useState(0)

  if (!ContentState.login) return <></>
  return (
    <section className="login-content2">
      <div className="login-content2__container">
        {!step && (
          <FirstStep
            setStep={() => setStep(1)}
            isAuth
            setEmail={() => {}}
            content={ContentState.login}
          />
        )}
        {step == 1 && <RestartPassword setStep={() => setStep(0)} />}
      </div>
    </section>
  )
})

export default LoginContent2
